module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [(_vm.accountActivated === true) ? _c('div', {
    staticClass: "row"
  }, [_c('section', {
    staticClass: "activation__wrapper col-xs-12"
  }, [_c('img', {
    staticStyle: {
      "width": "80px",
      "height": "80px"
    },
    attrs: {
      "src": require("../../../assets/images/check-green.svg")
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "title-content --no-border mt-3 mb-3"
  }, [_vm._v(_vm._s(_vm.$t('ACCOUNT_WAS_ACTIVATED')))]), _vm._v(" "), _c('div', {
    staticClass: "buttons-group"
  }, [_c('router-link', {
    staticClass: "app-btn app-btn--big app-btn-primary",
    attrs: {
      "to": "/moje-konto",
      "tag": "button"
    }
  }, [_vm._v(_vm._s(_vm.$t('LOGIN_TO_ACCOUNT')) + "\n                ")])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.accountActivated === false) ? _c('div', {
    staticClass: "row"
  }, [_c('section', {
    staticClass: "activation__wrapper col-xs-12"
  }, [_c('div', {
    staticClass: "row my-4"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/images/x-red.png")
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "title-deactivated ml-3"
  }, [_vm._v(_vm._s(_vm.$t('ACTIVATION_LINK_EXPIRED')))])]), _vm._v(" "), _c('div', {
    staticClass: "buttons-group"
  }, [_c('router-link', {
    staticClass: "app-btn app-btn--big app-btn-primary",
    attrs: {
      "to": "/wyslij-kod-aktywacyjny",
      "tag": "button"
    }
  }, [_vm._v(_vm._s(_vm.$t('SEND_ACTIVATION_LINK_AGAIN')) + "\n                ")])], 1)])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5b56e3a4","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/activate-account/activate-account.vue
// module id = 1206
// module chunks = 0